import { Suspense } from "react";
import { styled } from "@mui/material";
import { ErrorBoundary } from "react-error-boundary";

import { useUuidContext } from "hooks/routerHooks";

import { MainStyles } from "layout/MainStyles.";

import { AlertErrorBoundary } from "components/boundary/AlertErrorBoundary";
import { ResultPageSkeleton } from "components/skeletons/ResultPageSkeleton";
import { ResultPrintPageLoader } from "components/loader/ResultPrintPageLoader";

export function ResultPrintPage() {
  const { uuid } = useUuidContext();
  return (
    <Styles>
      <ErrorBoundary
        FallbackComponent={(props) => <AlertErrorBoundary {...props} />}
      >
        <Suspense fallback={<ResultPageSkeleton />}>
          <ResultPrintPageLoader uuid={uuid} />
        </Suspense>
      </ErrorBoundary>
    </Styles>
  );
}

const Styles = styled(MainStyles)`
  overflow: auto;
  flex-direction: column;

  @media print {
    display: block;
    overflow: unset;
  }
`;
